// extracted by mini-css-extract-plugin
module.exports = {"root":"Breadcrumb_root__3gGC6","chevron":"Breadcrumb_chevron__x90M_","link":"Breadcrumb_link__2k9ve"};